import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import MicroClass from '@/components/MicroClass/MicroClass'
import areaQualityCourse from '@/components/areaQualityCourse/areaQualityCourse'
import SynchronizeResources from '@/components/SynchronizeResources/SynchronizeResources'
import lessonPackage from '@/components/lessonPackage/lessonPackage'
import OpenClass from '@/components/OpenClass/OpenClass'
import testPaper from '@/components/testPaper/testPaper'
import questionBank from '@/components/questionBank/questionBank'
import areaQualityResources from '@/components/areaQualityResources/areaQualityResources'

Vue.use(Router)
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  model:'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component:() => import('../components/home/home.vue'),
      children:[
        {
          path: '',
          name: 'index',
          component: index          //资源中心首页
        },
        {
          path: '/MicroClass',
          name: 'MicroClass',
          component: MicroClass             //学堂微课
        },
        {
          path: '/areaQualityCourse',
          name: 'areaQualityCourse',
          component: areaQualityCourse      //区域优质课
        },
        {
          path: '/SynchronizeResources',
          name: 'SynchronizeResources',
          component: SynchronizeResources     //同步资源
        },
        {
          path: '/lessonPackage',
          name: 'lessonPackage',
          component: lessonPackage      //备课包
        },
        {
          path: '/OpenClass',
          name: 'OpenClass',
          component: OpenClass            //公开课
        },
        {
          path: '/testPaper',
          name: 'testPaper',
          component: testPaper            //试卷库
        },
        {
          path: '/questionBank',
          name: 'questionBank',
          component: questionBank            //试卷库
        },
        {
          path: '/areaQualityResources',
          name: 'areaQualityResources',
          component: areaQualityResources            //区域优质资源
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component:() => import('@/components/login/login.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js